<app-loader *ngIf="isLoading"></app-loader>

<div class="page-container" style="position: relative">
	<div class="page-header">
		<div class="row">
			<div class="col-lg-12">
				<div class="card">
					<!-- HEADER: TÍTULO + SEARCH -->
					<div class="card-header align-items-center d-flex flex-wrap">
						<h4 class="card-title mb-0 flex-grow-1">Campaigns</h4>
						<div class="col-6">
							<input type="text" class="form-control" placeholder="Search" (input)="campaignSearch($event)" />
						</div>
					</div>

					<!-- BODY: TABLA -->
					<div class="card-body p-0">
						<div class="fullscreen-table">
							<ngx-datatable class="material striped" [rows]="campaigns" [columnMode]="'flex'" [headerHeight]="50" [rowHeight]="'auto'" [scrollbarH]="true">
								<ngx-datatable-column prop="name" name="Name" [flexGrow]="3" [minWidth]="120" headerClass="cell-center title-header" cellClass="cell-center"> </ngx-datatable-column>

								<ngx-datatable-column prop="timezone" name="Timezone" [flexGrow]="1" [minWidth]="100" headerClass="cell-center title-header" cellClass="cell-center"> </ngx-datatable-column>

								<ngx-datatable-column prop="total_prospects" name="Records" [flexGrow]="1" [minWidth]="100" headerClass="cell-center title-header" cellClass="cell-center"> </ngx-datatable-column>

								<ngx-datatable-column prop="leads_needed" name="Needed" [flexGrow]="1" [minWidth]="100" headerClass="cell-center title-header" cellClass="cell-center"> </ngx-datatable-column>

								<ngx-datatable-column prop="industry" name="Industry" [flexGrow]="1.5" [minWidth]="150" headerClass="cell-center title-header" cellClass="cell-center">
									<ng-template let-row="row" ngx-datatable-cell-template>
										{{ row.industry_name }}
									</ng-template>
								</ngx-datatable-column>

								<ngx-datatable-column prop="types" name="Types" [flexGrow]="1" [minWidth]="60" [maxWidth]="80" headerClass="cell-center title-header" cellClass="cell-left">
									<ng-template let-row="row" ngx-datatable-cell-template>
										<ng-container *ngFor="let icon of getIcons(row.types)">
											<i [ngClass]="icon" style="font-size: 15px; margin-right: 2px"></i>
										</ng-container>
									</ng-template>
								</ngx-datatable-column>

								<ngx-datatable-column [flexGrow]="2.5" [minWidth]="260" name=" " headerClass="cell-center title-header" cellClass="actions-cell">
									<ng-template let-row="row" ngx-datatable-cell-template>
										<div class="actions-wrapper">
											<div style="position: relative; display: inline-block">
												<button type="button" class="btn btn-sm btn-icon" [ngbTooltip]="row.total_callbacks > 0 ? 'Callbacks: ' + row.total_callbacks : 'No callbacks'" [routerLink]="['/callback', row.id, row.alias]" [style.visibility]="row.total_callbacks > 0 ? 'visible' : 'hidden'" style="background: transparent; font-size: 28px">🔥</button>
												<span [style.visibility]="row.total_callbacks > 0 ? 'visible' : 'hidden'" style="position: absolute; top: 63%; left: 50%; transform: translate(-50%, -50%); color: #454545; font-weight: bold; font-size: 14px; pointer-events: none">
													{{ row.total_callbacks }}
												</span>
											</div>

											<button *ngIf="row.id && row.alias" type="button" class="btn btn-sm btn-icon me-1" ngbTooltip="Open Calendar" style="background-color: #f7b84b" (click)="openCalendar(row.id, row.alias)">
												<i class="las la-calendar" style="color: white"></i>
											</button>

											<button type="button" class="btn btn-sm btn-icon me-1" ngbTooltip="Start Dialing" style="background-color: #f06548" (click)="goToProspect(row.id, row.alias)">
												<i class="las la-phone" style="color: white"></i>
											</button>

											<button type="button" class="btn btn-primary btn-sm btn-icon me-1" ngbTooltip="Reschedules" (click)="openReschedules(row)">
												<i class="las la-edit"></i>
											</button>

											<button *ngIf="row.reschedules" type="button" class="btn btn-info btn-sm btn-icon me-1" ngbTooltip="Pending Reschedules" (click)="goToReschedules(row)">
												<i class="las la-clock"></i>
											</button>
										</div>
									</ng-template>
								</ngx-datatable-column>
							</ngx-datatable>
						</div>
					</div>
					<!-- FIN BODY -->
				</div>
			</div>
		</div>
	</div>
</div>
